import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { UnorderedListOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import logo from "@/assets/logo.png";
import "./index.less";
import { getCurrentLanguage, setLanguage, navItems } from "@/store/data/global";

const MOBILE_BREAKPOINT = 768;

const NewNav = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const currentLanguage = useSelector(getCurrentLanguage);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobile(mobile);
      if (!mobile) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = isMobile && isMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobile, isMenuOpen]);

  // 滚动监听（仅 PC）
  useEffect(() => {
    if (isMobile) return;

    if (!isHomePage) {
      setIsScrolled(true);
      return;
    }

    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHomePage, isMobile]);

  const isActiveLink = (navItem) => {
    if (location.pathname === "/") return navItem.key === "/";
    return location.pathname === navItem.path;
  };

  const closeMobileMenu = () => {
    setIsMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const langSwitch = (
    <div className="lang flex">
      {["JA", "EN"].map((code) => (
        <div className="lang_item" key={code}>
          <span
            className={currentLanguage === code ? "active" : ""}
            onClick={() => dispatch(setLanguage(code))}
          >
            {code === "JA" ? "日本語" : "EN"}
          </span>
        </div>
      ))}
    </div>
  );

  return (
    <>
      {isMobile && isMenuOpen && (
        <div
          className="nav-mobile-overlay"
          onClick={closeMobileMenu}
          aria-hidden="true"
        />
      )}
      <div
        className={`new_nav_page ${isScrolled ? "scrolled" : ""} ${
          isHomePage ? "home-page" : "other-page"
        } ${isMobile ? "mobile-nav" : ""} ${isMenuOpen ? "menu-open" : ""}`}
      >
        <div className="nav_warp">
          {/* Logo */}
          <div className="logo">
            <Link to="/">
              <img src={logo} alt="Logo" className="logo-image" />
            </Link>
          </div>

          {isMobile ? (
            <div className="nav_mobile_actions">
              <button
                type="button"
                className={`mobile-menu-btn ${isMenuOpen ? "is-open" : ""}`}
                onClick={toggleMobileMenu}
                aria-expanded={isMenuOpen}
                aria-label="Menu"
              >
                <span>Menu</span>
                <UnorderedListOutlined />
              </button>
              {langSwitch}
            </div>
          ) : (
            <>
              {langSwitch}

              {/* PC 端：保持原有导航结构 */}
              {!isScrolled ? (
                <div className="nav_list">
                  {navItems.map((item) => (
                    <div className="nav_item" key={item.key}>
                      <Link
                        to={item.path}
                        className={isActiveLink(item) ? "active" : ""}
                      >
                        {item.name[currentLanguage]}
                      </Link>
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  className="short_nav_list"
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <div className={`short-cube ${isHovered ? "hidden" : ""}`}>
                    <p>Menu</p>
                    <UnorderedListOutlined />
                  </div>

                  <div className={`long_nav ${isHovered ? "visible" : "hidden"}`}>
                    {navItems.map((item) => (
                      <div className="nav_item" key={item.key}>
                        <Link
                          to={item.path}
                          className={isActiveLink(item) ? "active" : ""}
                        >
                          {item.name[currentLanguage]}
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        {isMobile && (
          <div className={`mobile-nav-panel ${isMenuOpen ? "is-open" : ""}`}>
            {navItems.map((item) => (
              <Link
                key={item.key}
                to={item.path}
                className={`mobile-nav-link ${
                  isActiveLink(item) ? "active" : ""
                }`}
                onClick={closeMobileMenu}
              >
                {item.name[currentLanguage]}
              </Link>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default NewNav;
